
import Vue from 'vue';
import OeamtcSelect, { OeamtcSelectValue } from '@components/new-styleguide/form/OeamtcSelect.vue';
import { Component, Prop } from 'vue-property-decorator';
import { Tag } from '@clients/myTrips';

@Component({
  name: 'TagSelect',
  components: {
    OeamtcSelect
  }
})
export default class TagSelect extends Vue {
  @Prop()
  private value: Tag;

  @Prop()
  private callbackTripId: string;

  @Prop({ required: true })
  private tags: Tag[];

  @Prop({ default: false })
  private disabled: boolean;

  private handleInput(index: number) {
    if (index === 0) {
      this.$emit('input', undefined);
    } else {
      this.$emit('input', this.tags[index - 1]);
    }
  }

  get valueIndex() {
    if (!this.value) {
      return 0;
    }
    return this.tags.findIndex(tag => tag.id === this.value.id) + 1;
  }

  get tagOptions(): OeamtcSelectValue[] {
    const mappedTags = this.tags.map(tag => ({
      name: tag.name,
      tagIcon: {
        value: tag.iconName,
        color: tag.color,
        fill: 'white',
        position: 7
      }
    }));

    return [{ name: 'Keine Auswahl' }, ...mappedTags];
  }
}
